export const enum MaxHouseSalePriceEnum {
  None,
  NoMax = 0,
  UpTo1Million = 1,
  UpTo2Million = 2,
  UpTo5Million = 3,
}
